import { formatGal, formatToEighths } from "@/lib/tank";

const fmtH = (h) => (Number.isInteger(h) ? `${h}"` : formatToEighths(h));

function Line({ kind, h, gal, t }) {
  return (
    <div className={`zone-line zone-line-${kind}`} data-testid={`chart-line-${kind}`}>
      {kind === "90" ? t("90% overfill shutoff — {h} · {g} gal", { h: formatToEighths(h), g: formatGal(gal) })
        : t("95% max safe fill — {h} · {g} gal", { h: formatToEighths(h), g: formatGal(gal) })}
    </div>
  );
}

export function ChartTable({ chart, startH, finalH, listRef, t }) {
  const { rows, h90, h95, cap90, cap95 } = chart;
  const near = (x) => rows.reduce((b, r, i) => (Math.abs(r.h - x) < Math.abs(rows[b].h - x) ? i : b), 0);
  const si = startH > 0 ? near(startH) : -1, fi = finalH > 0 ? near(finalH) : -1;
  const out = [];
  let put90 = false, put95 = false;
  rows.forEach((r, i) => {
    if (!put90 && r.h >= h90 - 1 / 16) { out.push(<Line key="l90" kind="90" h={h90} gal={cap90} t={t} />); put90 = true; }
    if (!put95 && r.h >= h95 - 1 / 16) { out.push(<Line key="l95" kind="95" h={h95} gal={cap95} t={t} />); put95 = true; }
    const mark = i === fi ? "row-final" : i === si ? "row-start" : "";
    out.push(
      <div key={r.h} className={`chart-row zone-${r.zone || "none"} ${Number.isInteger(r.h) ? "" : "row-fine"} ${mark}`} data-h={r.h} data-testid={`chart-row-${r.h}`}>
        <span className="c-inch inch-cell">{i === fi ? "▸ " : i === si ? "● " : ""}{fmtH(r.h)}</span>
        <span className="c-vol">
          <span className="vol-text">{formatGal(r.vol)} gal</span>
          <span className="sub-cell">{`+${formatGal(r.gpi)} gal/in · ${r.pct.toFixed(1)}%`}</span>
        </span>
        <span className="c-room mono">{r.room90 >= 0 ? `${formatGal(r.room90)} gal` : <>0 gal<small>{t("over by {g}", { g: formatGal(-r.room90) })}</small></>}</span>
        <span className="c-to90 mono">{r.to90 > 0 ? formatToEighths(r.to90) : "—"}</span>
      </div>
    );
  });
  return (
    <>
      <div className="chart-head chart-head-4">
        <span className="c-inch">{t("Stick")}</span><span className="c-vol">{t("Gallons")}</span>
        <span className="c-room">{t("90% room")}</span><span className="c-to90">{t("To 90%")}</span>
      </div>
      <div className="chart-list" data-testid="chart-list" ref={listRef}>{out}</div>
    </>
  );
}

export const ZoneLegend = ({ t }) => (
  <div className="zone-legend" data-testid="chart-zone-legend">
    <span className="zl zl-belly">{t("Belly 35–65%: most gal per inch, level rises slowly")}</span>
    <span className="zl zl-curve">{t("Curve 75–89%: level rises up to 2× faster")}</span>
    <span className="zl zl-orange">{t("90%: drop-tube shutoff — throttle back")}</span>
    <span className="zl zl-red">{t("95%: max safe fill — leave room for hose drain")}</span>
  </div>
);
